import logo from '../images/ensenartecomplete.png';
import './carga.css';

const carga = {
  mostrarCarga: () => {
    // Remove existing loading screen if any
    const existing = document.getElementById('loading-screen');
    if (existing) existing.remove();

    // Create the loading screen element
    const loadingDiv = document.createElement('div');
    loadingDiv.id = 'loading-screen';
    loadingDiv.className = 'loading-screen';
    loadingDiv.innerHTML = `
      <div class="loader-wrcargaer">
        <div class="loader-ring"></div>
        <div class="loader-inner">
          <img src="${logo}" alt="EnsenArte logo" class="loader-logo" />
        </div>
      </div>
    `;

    // Append to body
    document.body.appendChild(loadingDiv);
  },

  ocultarCarga: () => {
    const loadingDiv = document.getElementById('loading-screen');
    if (loadingDiv) {
      loadingDiv.remove();
    }
  }
};

export default carga;